<template>
	<div>
	   <div class="waga" v-show="show">
		<div class="title"> {{ title }} </div><br/><br/>
		<div class="stitle stittleerror"> 
		<p>Błąd. {{ subtitle }}</p> 
		</div>
	    </div>
	    <div class="podwaga">
		<div class="wleft">
        		<button class="wlabel"> WRÓĆ </button>
     		</div>
	    </div>
		<div class="wright">
			<button class="wlabel commit" @click="wrocdomenu"> WRÓĆ DO MENU </button>
		</div>
	</div>
</template>

<script>

import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
import "../../node_modules/@syncfusion/ej2-vue-inputs/styles/material.css";
import Vue from "vue";
import Storage from "./Storage";
import * as CONFIG from "./config.js";

export default {
  name: "waga",
  components: { 
  },
  props: {
    nazwa: String,
    wroc: String,
  },
  data: () => ({
	title: "",
	subtitle: "BŁĄD - wystąpił błąd przy zapisie danych do bazy. Twoje dane NIE zostały zapisane w bazie danych. \n" + "Spróbuj jeszcze raz.",
	show: true,
	whereto: "",
	backto: "",
	id_uzytkownika: -1,
  }),
  methods: {
	wrocclick() {
		this.$router.push({ path: this.backto + this.whereto });
	},
	wrocdomenu(){
		this.$router.push({ path: 'main' });
	},
  },
  mounted() {
	var params = this.$route.query;
        var prev = "";
        var prev3 = "";
	var id_dok_mag = "";
	var id_zlecenia = "";
	var id_odpadu = "";
	var id_skrzyni = "";
	var skrzyn = "";
	
        if (params["prev2"]) {
             prev = params["prev2"];
	     this.whereto="?prev=" + prev;
	}
	if (params["mag"]) {
	     id_dok_mag = params["mag"];
	     this.whereto += "&mag=" + id_dok_mag;
	}
	if (params["id_zlecenia"]) {
	     id_zlecenia = params["id_zlecenia"];
	     this.whereto += "&id_zlecenia=" + id_zlecenia;
	}
	if (params["id_odpadu"]) {
	     id_odpadu = params["id_odpadu"];
	     this.whereto += "&id_odpadu=" + id_odpadu;
	}
        if (params["id_skrzyni"]) {
             id_skrzyni = params["id_skrzyni"];
             this.whereto += "&id_skrzyni=" + id_skrzyni;
        }
        if (params["skrzyn"]) {
             skrzyn = params["skrzyn"];
             this.whereto += "&skrzyn=" + skrzyn;
        }
        if (params["prev3"]) {
             prev3 = params["prev3"];
             this.whereto += "&prev2=" + prev3 + '&error=1';
        }
	if (params["prev2"]) {
		var pp = params["prev2"];
		if (pp.indexOf("odpady") != -1) {
			this.title = "ODSORTY > ZLECENIA > ODSORTY > LISTA DOKUMENTÓW PZ > Opakowanie > Waga > Potwierdzenie";
			this.backto = "/waga";
		} else if (pp.indexOf("dokumentpzprzyjecie") != -1) {
			this.title = " PRZYJĘCIE WYROBU GOTOWEGO > ZLECENIA > LISTA DOKUMENTÓW PZ > Nośnik i Opakowanie > Waga > Potwierdzenie";
			this.backto = "/nosnikopakowanie";
		} else {
			this.title = "WYDANIE Z MAGAZYNU > ZLECENIA > LISTA DOKUMENTÓW PZ > Opakowanie > Waga > Potwierdzenie";
			this.backto = "/waga";
		}
	}
	if(params["error"]){
		var err = params["error"]
		this.subtitle = err
	}

	let that = this;
	document.querySelector(".wleft").addEventListener('click', function() { that.wrocclick(); } );
	//document.querySelector(".wright").addEventListener('click', function() { that.commitclick(); } );

    },
} 

</script>

<style>

.e-numeric.e-style .e-control.e-numerictextbox {
        color: royalblue;
        font-size: xx-large;
        border: 0px;
    }

/* csslint ignore:start */
    .e-numeric .e-input-group-icon.e-spin-up {
        content: "";
        /*color: rgba(0, 0, 0, 0.54);*/
    }

    .e-numeric .e-input-group-icon.e-spin-down {
        content: "";
        /*color: rgba(0, 0, 0, 0.54);*/
    }
    /* csslint ignore:end */

.waga {
	margin-bottom:5%;
}
.podwaga {
	clear:both;
	margin-top: 30px;
}
.commit {
	width: 200px;
	height: 50px;
}

.nazwa {
}

.stittleerror {
	height: 500px;
	color:red;
	font-size: 2em;
	font-weight: bold;
}
p{
	padding-top: 150px;
}

.wrap {
margin: 5% auto;
width: 240px;
}
.wright {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        right: 10px;
        text-align: right;
        background-color: #FFFFFF;
        /*padding-top: 10px;*/
        float: right;
        margin-top: 40px;
}
.wleft {
        width: 200px;
        height: 50px;
		position:fixed;
        bottom: 10px;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        /*margin-left: 400px;*/
}
.wlabel {
        width: 200px;
        height: 50px;

        background-color: #FFFFFF;
}

</style>




// WEBPACK FOOTER //
// src/components/PotwierdzenieERROR.vue